import { useState, useRef, useEffect } from "react";
import "./Navbar.css";
import "./Navbar.responsive.css";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import { useAuth } from "../../context/AuthContext";
import { NavLink } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";

const Navbar = ({ onMenuClick, sidebarExpanded = false }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const { user } = useAuth();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    const auth = getAuth();
    await signOut(auth); // ← kills the Firebase session
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("role");
    window.location.href = "/login";
  };

  return (
    <div className="topbar">
      <div className="header-left">
        <button
          type="button"
          className="menu-btn"
          onClick={onMenuClick}
          aria-label={sidebarExpanded ? "Collapse sidebar" : "Expand sidebar"}
          aria-expanded={sidebarExpanded}
        >
          <span className="material-symbols-outlined">
            {sidebarExpanded ? "menu_open" : "menu"}
          </span>
        </button>
        <h3>Admin Dashboard</h3>
      </div>

      <div className="topbar-right">
        {/* Notifications */}
        <Tooltip title="Notifications">
          <IconButton>
            <span className="material-symbols-outlined">notifications</span>
          </IconButton>
        </Tooltip>

        {/* Settings (hidden on very small screens — it's in the sidebar and profile menu) */}
        <Tooltip title="Settings">
          <IconButton className="topbar-settings">
            <span className="material-symbols-outlined">settings</span>
          </IconButton>
        </Tooltip>

        {/* Profile */}
        <div className="profile-wrapper" ref={dropdownRef}>
          <div
            className="profile-section"
            onClick={() => setDropdownOpen((prev) => !prev)}
          >
            <Avatar
              src={user?.imageUrl}
              sx={{ width: 34, height: 34, bgcolor: "#006663" }}
            >
              {user?.username?.charAt(0)?.toUpperCase() || "A"}
            </Avatar>
            <span className="username">{user?.username || "Admin"}</span>
            <span
              className={`material-symbols-outlined chevron ${dropdownOpen ? "open" : ""}`}
            >
              expand_more
            </span>
          </div>

          {dropdownOpen && (
            <div className="profile-dropdown">
              <div className="dropdown-header">
                <Avatar
                  src={user?.imageUrl}
                  sx={{ width: 40, height: 40, bgcolor: "#006663" }}
                >
                  {user?.username?.charAt(0)?.toUpperCase() || "A"}
                </Avatar>
                <div className="dropdown-header-info">
                  <span className="dropdown-name">
                    {user?.username || "Admin"}
                  </span>
                  <span className="dropdown-email">{user?.email || ""}</span>
                </div>
              </div>

              <div className="dropdown-divider" />

              <NavLink
                to="/settings"
                className="dropdown-item"
                onClick={() => setDropdownOpen(false)}
              >
                <span className="material-symbols-outlined">person</span>
                Profile
              </NavLink>

              <NavLink
                to="/settings"
                className="dropdown-item"
                onClick={() => setDropdownOpen(false)}
              >
                <span className="material-symbols-outlined">lock</span>
                Change Password
              </NavLink>

              <div className="dropdown-divider" />

              <button className="dropdown-item logout" onClick={handleLogout}>
                <span className="material-symbols-outlined">logout</span>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
